module.exports = __webpack_public_path__ + "assets/img/020101.8750b08a.svg";